import type { DateFormat, UpdateOrganizationInput } from "@repo/shared";
import { updateOrganizationDateFormatResponseSchema } from "@repo/shared";
import { authClient } from "../auth-client";
import { API_V1_PREFIX, apiRequestJson } from "../api-client";

export async function updateOrganization(organizationId: string, data: UpdateOrganizationInput) {
  return authClient.organization.update({
    organizationId,
    data: { name: data.name },
  });
}

export async function deleteOrganization(organizationId: string) {
  return authClient.organization.delete({ organizationId });
}

export async function updateOrganizationDateFormat(dateFormat: DateFormat) {
  // The API resolves the target org from the active-org header (auth context)
  // and enforces the owner-only guard server-side.
  return apiRequestJson({
    path: `${API_V1_PREFIX}/organization/date-format`,
    method: "PUT",
    body: { dateFormat },
    responseSchema: updateOrganizationDateFormatResponseSchema,
    badResponseMessage: "Unexpected response from server",
  });
}
